/**
 * Zod without its `new Function` probe, in the browser.
 *
 * Zod checks once whether it may compile parsers with `new Function`, inside
 * a try. Our Content-Security-Policy has no 'unsafe-eval', so the check is
 * refused and Zod carries on without it: nothing breaks. But the browser
 * still reports the refusal as a CSP violation, and Lighthouse takes four
 * points off Best Practices on every page for it (issue #75). `jitless` tells
 * Zod not to try.
 *
 * Imported first in main.tsx, so it runs before any module that defines or
 * uses a schema. Never fix this by adding 'unsafe-eval' to the policy.
 */

import { z } from 'zod'

z.config({ jitless: true })
